import React, { useState, useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useRouter } from "next/router";

export default function LoginLink(props) {
	const { className = "", linkText = "Login / Sign Up", size = 13, lineHeight = 28, color = "inherit" } = props;
	// const [redirectLink, setRedirectLink] = useState(false);
	const { getAccessTokenSilently, loginWithPopup, loginWithRedirect, user, isAuthenticated, isLoading } = useAuth0();
	// console.log({ user, isAuthenticated, isLoading });

	const router = useRouter();

	// useEffect(() => {
	// 	// setRedirectLink(window.location.href);
	// 	// console.log(redirectLink);
	// }, [typeof window !== "undefined" ? window.location.href : ""]);

	return (
		<span
			className={className}
			onClick={async (e) => {
				e.preventDefault();
				// await loginWithPopup();
				loginWithRedirect({
					appState: { prevPath: `${process.env.WEB_URL}${router.asPath}` },
				});
			}}
		>
			{linkText}

			<style jsx="true">{`
				span:hover {
					text-decoration: underline;
				}
				span {
					cursor: pointer;
					font-size: ${size}px;
					line-height: ${lineHeight}px;
					color: ${color};
				}
			`}</style>
		</span>
	);
}
